import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

export interface Extra {
  id: number;
  name: string;
  price: number;
  sort_order: number;
}

const FALLBACK_EXTRAS: Extra[] = [
  { id: -1, name: "Ketchup", price: 0.5, sort_order: 1 },
  { id: -2, name: "Mayonnaise", price: 0.5, sort_order: 2 },
  { id: -3, name: "Extra Sausage", price: 2.5, sort_order: 3 },
];

/**
 * Live list of paid add-ons (extras) with the prices set by the admin.
 */
export function useExtras() {
  const [extras, setExtras] = useState<Extra[]>(FALLBACK_EXTRAS);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      const { data, error } = await supabase
        .from("extras")
        .select("id, name, price, sort_order")
        .eq("is_active", true)
        .order("sort_order", { ascending: true });

      if (cancelled) return;
      if (!error && data) {
        setExtras(
          data.map((e) => ({
            id: e.id,
            name: e.name,
            price: Number(e.price) || 0,
            sort_order: e.sort_order ?? 0,
          })),
        );
      }
      setLoading(false);
    };

    load();

    const channel = supabase
      .channel("burgers-extras-realtime")
      .on("postgres_changes", { event: "*", schema: "public", table: "extras" }, () => load())
      .subscribe();

    return () => {
      cancelled = true;
      supabase.removeChannel(channel);
    };
  }, []);

  return { extras, loading };
}
